'use client';
import React from 'react';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import { theme } from '@/components/features/theme/theme';

const Title = ({
                   text,
                   tag = 'h2', // New prop to specify the tag
                   fontSize,
                   fontSizeSm,
                   fontWeight,
                   color,
                   letterSpacing,
                   lineheight,
                   lineheightSm,
                   textTransform,
                   textAlign,
                   textDecoration,
                   fontStyle,
                   textShadow,
                   margin,
                   padding,
                   bordercolor,
                   borderWidth,
                   borderStyle,
                   variant,
                   center,
                   classname,
                   marginSm,
                   width,
                   backgroundColor,
                   onClick,
                   onMouseEnter,
                   onMouseLeave,
                   onDoubleClick,
                   animClass,
               }) => {
    const CustomTag = tag;

    return (
        <StyledTitle
            className={`title ${classname || ''}`}
            fontSize={fontSize}
            fontSizeSm={fontSizeSm}
            fontWeight={fontWeight}
            color={color}
            lineheight={lineheight}
            lineheightSm={lineheightSm}
            letterSpacing={letterSpacing}
            textTransform={textTransform}
            textAlign={textAlign}
            textDecoration={textDecoration}
            fontStyle={fontStyle}
            textShadow={textShadow}
            margin={margin}
            padding={padding}
            variant={variant}
            center={center}
            marginSm={marginSm}
            width={width}
            bordercolor={bordercolor}
            borderWidth={borderWidth}
            borderStyle={borderStyle}
            backgroundColor={backgroundColor}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onDoubleClick={onDoubleClick}>
            <CustomTag className={`${animClass ? animClass : ''}`} data-scroll data-scroll-repeat>
                {ReactHtmlParser(text)}
            </CustomTag>
        </StyledTitle>
    );
};

// Styled Component with enhanced props
const StyledTitle = styled.div`
    position: relative;
    margin: ${props => props.margin || '0'};
    width: ${props => props.width || 'fit-content'};
    font-family: ${theme.colors.title};
    text-align: ${props => props.textAlign || (props.center ? 'center' : 'left')};
    padding: ${props => props.padding || '0'};
    background-color: ${props => props.backgroundColor || 'transparent'};
    border-color: ${props => props.bordercolor};
    border-width: ${props => props.borderWidth || '0'};
    border-style: ${props => props.borderStyle || 'solid'};

    h1 {
        font-size: ${props => props.fontSize || theme.fontSizes.h1};
        font-family: ${theme.fonts.heading};
        font-weight: ${props => props.fontWeight || theme.fontWeights.h1};
        line-height: ${props => props.lineheight || theme.lineHeights.h1};
        color: ${props => props.color || theme.colors.text};
        i {
            font-family: "PP Migra Italic", serif;
        }
    }

    h2 {
        font-size: ${props => props.fontSize || theme.fontSizes.h2};
        font-family: ${theme.fonts.heading};
        font-weight: ${props => props.fontWeight || theme.fontWeights.h2};
        line-height: ${props => props.lineheight || theme.lineHeights.h2};
        color: ${props => props.color || theme.colors.text};
       
        i{
            font-family: "PP Migra Italic", serif;
        }
        
    }

    h3 {
        font-size: ${props => props.fontSize || theme.fontSizes.h3};
        font-weight: ${props => props.fontWeight || theme.fontWeights.regular};
        line-height: ${props => props.lineheight || theme.lineHeights.h3};
        color: ${props => props.color || theme.colors.text};
       
        i{
            font-family: "PP Migra Italic", serif;
        }
    }

    h4 {
        font-size: ${props => props.fontSize || theme.fontSizes.h4};
        font-weight: ${props => props.fontWeight || theme.fontWeights.regular};
        color: ${props => props.color || theme.colors.text};
       
        i{
            font-family: "PP Migra Italic", serif;
        }
    }

    h5 {
        font-size: ${props => props.fontSize || theme.fontSizes.h5};
        font-weight: ${props => props.fontWeight || theme.fontWeights.regular};
        color: ${props => props.color || theme.colors.text};
        
        i{
            font-family: "PP Migra Italic", serif;
        }
    }

    h6 {
        font-size: ${props => props.fontSize || theme.fontSizes.h6};
        font-weight: ${props => props.fontWeight || theme.fontWeights.regular};
        color: ${props => props.color || theme.colors.text};
      
        i{
            font-family: "PP Migra Italic", serif;
        }
    }


    @media (max-width: 767px) {
        margin: ${props => props.marginSm || props.margin};
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p {
            font-size: ${props => props.fontSizeSm || '2.5rem'} !important;
            line-height: ${props => props.lineheightSm || '2.8rem'} !important;
        }
    }
`;

export default Title;
